module.exports = __webpack_public_path__ + "static/media/stupid-cupid.9d8ce53a.gif";